import { serializeStateOverride } from "../../utils/stateOverride.js";
export const estimateUserOperationGas = async (client, args) => {
    return client.request({
        method: "eth_estimateUserOperationGas",
        params: args.stateOverride != null
            ? [
                args.request,
                args.entryPoint,
                serializeStateOverride(args.stateOverride),
            ]
            : [args.request, args.entryPoint],
    });
};
//# sourceMappingURL=estimateUserOperationGas.js.map